import type { HttpContext, HttpParams } from '@angular/common/http';
import type { ClassProvider } from '@angular/core';

export interface AuthConfigI {
  authUrl: string;
  appUrl: string;
  webAppUrl: string;
  hasHttps: boolean;
}

export enum CookieKey {
  SuperadminAccessToken = 'superadmin_access_token',
  AccessToken = 'access_token',
  AccessTokenExpiresAt = 'access_token_expires_at',
  Company = 'company',
  OrgGuid = 'org_guid',
}

export interface HttpApiRequestOptions {
  headers?:
    | (Record<string, string | []> & {
        'x-json-accent'?: 'snake' | 'pascal' | 'camel' | [];
      } & IdentityHeaders)
    | {};
  skipURLBuild?: boolean;
  responseType?: 'json' | 'text';
  addToken?: boolean;
  skipCompany?: boolean;
  httpContext?: HttpContext;
}

export enum IdentityHeader {
  Client = 'x-recruitee-client',
  Env = 'x-recruitee-env',
  TsApp = 'x-ts-app',
}

export type IdentityHeaders = Partial<Record<IdentityHeader, string>>;

export abstract class HttpRequestData {
  public abstract buildUrl(path: string, requestOptions?: HttpApiRequestOptions): string;
  public provideAuthHeaders(): { Authorization: string } | {} {
    return {};
  }
  public buildSignedUrl(path: string, search?: HttpParams): string | null {
    return null;
  }
  public abstract provideIdentityHeaders(isE2e: boolean): IdentityHeaders;
}

export interface HttpRequestDataProvider extends ClassProvider {
  provide: typeof HttpRequestData;
}
